import React from "react";
import { FaFacebookF } from "react-icons/fa";
import Header from "../../Components/Header";
import Footer from "./Footer";

const Home: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      {/* HEADER */}
     <Header></Header>

      {/* MAIN CONTENT */}
      <main className="flex-grow">
        <section className="max-w-6xl mx-auto px-4 py-12 text-center">
          {/* Nombre y Logo */}
          <div className="mb-6">
            <h2 className="text-4xl md:text-5xl font-extrabold text-gray-800">
              MyBot Service
            </h2>
            <p className="mt-4 text-lg text-gray-600">
              Automatiza tu atención al cliente con inteligencia artificial.
              Chatbots en WhatsApp listos para tu negocio.
            </p>
          </div>

          {/* Imágenes AI / Chatbot */}
          <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="rounded-lg overflow-hidden shadow-md">
              <img
                src="\AI Messages.png"
                alt="Chatbot AI"
                className="w-full h-56 object-cover"
              />
              <p className="mt-4 text-lg text-gray-600">
                Atiende tus cliente 24/7 usando modelos de AI conversacionales.
              </p>
            </div>

            <div className="rounded-lg overflow-hidden shadow-md">
              <img
                src="\ChatbotServices.jpeg"
                alt="WhatsApp Bot"
                className="w-full h-56 object-cover"
              />
              <p className="mt-4 text-lg text-gray-600">
                Gestionar sus servicios, productos o consultas a traves de chatbots a la medida, personaliza los menus y tu arbol de decisiones
              </p>
            </div>

            <div className="rounded-lg overflow-hidden shadow-md">
              <img
                src="\Automation image.jpg"
                alt="Automation"
                className="w-full h-56 object-cover"
              />
              <p className="mt-4 text-lg text-gray-600 text-center">
                Automatiza tareas a traves de tu chatbot, envia correos, actualiza tus archivos en la nube, integra con tus sistemas a traves de APIs.
              </p>
            </div>
          </div>
        </section>
      </main>

      {/* FOOTER */}
      <Footer></Footer>
    </div>
  );
};

export default Home;
